export enum UnableToVerifyReason {
  NewJobInsufficientHistory = 'NewJobInsufficientHistory',
  RelocatingToUk = 'RelocatingToUk',
  ReducedPayParentalLeave = 'ReducedPayParentalLeave',
  VariableOrCommissionIncome = 'VariableOrCommissionIncome',
  TechnicalFailure = 'TechnicalFailure',
  BankNotSupported = 'BankNotSupported',
  IncomeTypeNotSupported = 'IncomeTypeNotSupported',
  FixedTermOpenBankingNa = 'FixedTermOpenBankingNa',
  ApplicantRefusedPrivacy = 'ApplicantRefusedPrivacy',
  ApplicantRefusedNoReason = 'ApplicantRefusedNoReason',
  DissatisfiedWithEvidence = 'DissatisfiedWithEvidence',
}

export const UNABLE_TO_VERIFY_REASON_OPTIONS: {
  value: UnableToVerifyReason
  label: string
  infoText?: string
}[] = [
  {
    value: UnableToVerifyReason.NewJobInsufficientHistory,
    label: 'New job - insufficient payment history',
  },
  {
    value: UnableToVerifyReason.RelocatingToUk,
    label: 'Relocating to the UK - limited UK financial history',
  },
  {
    value: UnableToVerifyReason.ReducedPayParentalLeave,
    label: 'Reduced pay - maternity/paternity leave',
  },
  {
    value: UnableToVerifyReason.VariableOrCommissionIncome,
    label: 'Variable or commission-based income',
  },
  {
    value: UnableToVerifyReason.TechnicalFailure,
    label: 'Technical or connectivity failure',
  },
  {
    value: UnableToVerifyReason.BankNotSupported,
    label: 'Bank or building society not supported',
  },
  {
    value: UnableToVerifyReason.IncomeTypeNotSupported,
    label: 'Income type not supported by trusted sources',
  },
  {
    value: UnableToVerifyReason.FixedTermOpenBankingNa,
    label: 'Fixed-term contract - Open Banking not applicable',
  },
  {
    value: UnableToVerifyReason.ApplicantRefusedPrivacy,
    label: 'Applicant refused - privacy concerns',
    infoText:
      'The applicant was eligible to connect to a trusted source for income verification. They chose not to due to privacy concerns.',
  },
  {
    value: UnableToVerifyReason.ApplicantRefusedNoReason,
    label: 'Applicant refused - no reason given',
    infoText:
      'The applicant was eligible to connect to a trusted source for income verification. They chose not to and an insufficient reason was given.',
  },
  {
    value: UnableToVerifyReason.DissatisfiedWithEvidence,
    label: 'Dissatisfied with evidence provided',
    infoText:
      'The evidence provided by the applicant was not sufficient to verify income through a trusted source.',
  },
]

export const getReasonLabel = (reason: string): string =>
  UNABLE_TO_VERIFY_REASON_OPTIONS.find(o => o.value === reason)?.label ?? reason

export const getReasonInfoText = (reason: UnableToVerifyReason): string | undefined =>
  UNABLE_TO_VERIFY_REASON_OPTIONS.find(o => o.value === reason)?.infoText
